import UpcomingCard from './UpcomingCard';
import TopOpportunities from './TopOpportunities';
import WeeklyStats from './WeeklyStats';
import CustomerTable from './CustomerTable';

const MainDashboard = () => {
  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center space-y-4 lg:space-y-0">
        <div>
          <h1 className="text-3xl font-bold text-[#FFFFFF]">Hello, Al Razzaq</h1>
          <p className="text-[#B0B0B0] mt-1">Welcome back! Here's what's happening with your portfolio today.</p>
        </div>
        <div className="text-right">
          <div className="text-sm text-[#B0B0B0]">Current Date</div>
          <div className="text-lg font-semibold text-[#FFFFFF]">{new Date().toLocaleDateString('en-US', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}</div>
        </div>
      </div>
      
      {/* KPI Cards Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="kpi-card">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-[#B4E50D] rounded-xl flex items-center justify-center">
              <span className="text-[#0A0A0A] text-xl">👥</span>
            </div>
            <div className="text-right">
              <div className="text-sm text-[#B0B0B0]">+33.45%</div>
              <div className="text-xs text-[#B4E50D]">vs last week</div>
            </div>
          </div>
          <div className="text-3xl font-bold text-[#FFFFFF]">5,097</div>
          <div className="text-sm text-[#B0B0B0] mt-1">New Customers</div>
        </div>

        <div className="kpi-card">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-[#B4E50D] rounded-xl flex items-center justify-center">
              <span className="text-[#0A0A0A] text-xl">💰</span>
            </div>
            <div className="text-right">
              <div className="text-sm text-[#B0B0B0]">-12.45%</div>
              <div className="text-xs text-[#FF6B6B]">vs last week</div>
            </div>
          </div>
          <div className="text-3xl font-bold text-[#FFFFFF]">47,403</div>
          <div className="text-sm text-[#B0B0B0] mt-1">Total Revenue</div>
        </div>

        <div className="kpi-card">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-[#B4E50D] rounded-xl flex items-center justify-center">
              <span className="text-[#0A0A0A] text-xl">📊</span>
            </div>
            <div className="text-right">
              <div className="text-sm text-[#B0B0B0]">+62.52%</div>
              <div className="text-xs text-[#B4E50D]">vs last week</div>
            </div>
          </div>
          <div className="text-3xl font-bold text-[#FFFFFF]">25.81%</div>
          <div className="text-sm text-[#B0B0B0] mt-1">Engagement Rate</div>
        </div>

        <div className="kpi-card">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-[#B4E50D] rounded-xl flex items-center justify-center">
              <span className="text-[#0A0A0A] text-xl">⏱️</span>
            </div>
            <div className="text-right">
              <div className="text-sm text-[#B0B0B0]">+4.46%</div>
              <div className="text-xs text-[#B4E50D]">vs last week</div>
            </div>
          </div>
          <div className="text-3xl font-bold text-[#FFFFFF]">45.4</div>
          <div className="text-sm text-[#B0B0B0] mt-1">Avg. Response Time (min)</div>
        </div>
      </div>
      
      {/* Main Dashboard Content */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <UpcomingCard />
        <TopOpportunities />
        <WeeklyStats />
      </div>
      
      <CustomerTable />
    </div>
  );
};

export default MainDashboard;